import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";
import {
  CrewImage,
  EnterButton,
  HomeStyle,
  LoginCard,
  LoginField,
  SesiImage,
  SesiImageWrapper,
  StaticImage,
  VersionNumber,
  WrapContent,
  WrapContentLoginCard,
} from "../../styles/ResetPassword";
import BACKGROUNDIMAGE from "../../assets/img/backgroundImage.png";
import SESI from "../../assets/img/sesi.png";
import CREW from "../../assets/img/crew.png";
import { version } from "../../utils/constants";
import { changePassword } from "../../data/services/enterprise_service";
import { toast } from "react-toastify";

export default function ChangePassword() {
  const navigate = useNavigate();
  const location = useLocation();
  const [code, setCode] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");

  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");

  const handleEnterButton = async () => {
    if (!token) {
      setError("Token inválido ou expirado.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("As senhas não coincidem.");
      return;
    }

    try {
      const response = await changePassword(token, parseInt(code), newPassword);
      console.log("Senha alterada com sucesso!", response);
      toast.success("Senha alterada com sucesso!", {
              position: "bottom-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
      navigate("/"); 
    } catch (err) {
      setError("Erro ao trocar senha. Verifique os dados e tente novamente.");
      toast.error("Erro ao alterar a senha.");
    }
  };

  return (
    <HomeStyle>
      <WrapContent>
        <SesiImageWrapper>
          <SesiImage src={SESI} />
          <VersionNumber>{version}</VersionNumber>
        </SesiImageWrapper>
        <h1>PORTAL DO CLIENTE</h1>
        <LoginCard>
          <WrapContentLoginCard>
            <h1>Validação</h1>
            <h2>Preencha com o código recebido no email selecionado.</h2>
            <LoginField
              placeholder="Código de redefinição de senha"
              value={code}
              onChange={(e) => setCode(e.target.value)}
            />
            <h3>Sua senha deve possuir no mínimo:</h3>
            <h3>1 letra maiúscula</h3>
            <h3>1 caractere especial</h3>
            <h3>1 número</h3>
            <LoginField
              type="password"
              placeholder="Nova senha"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <LoginField
              type="password"
              placeholder="Repetir nova senha"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
            {error && <p style={{ color: "red" }}>{error}</p>}
            <EnterButton onClick={handleEnterButton}>Concluir</EnterButton>
          </WrapContentLoginCard>
        </LoginCard>
        <StaticImage src={BACKGROUNDIMAGE} />
      </WrapContent>
    </HomeStyle>
  );
}
